import {
  rotatePoint,
  rotateRectangle,
  rectangle,
  type QuarterTurns,
} from './studyPdfAnnotationGeometry';
import { pdfColour, type PdfDraft, type PdfPoint } from './studyPdfPalette';
import type { StudyPdfAnnotation } from './studyApi';

export function StudyPdfMarkLayer({
  items,
  draft,
  notePoint,
  rotation,
}: {
  items: StudyPdfAnnotation[];
  draft: PdfDraft;
  notePoint: PdfPoint | null;
  rotation: QuarterTurns;
}) {
  const points = (values: PdfPoint[]) =>
    values
      .map((point) => {
        const displayed = rotatePoint(point, rotation);
        return [displayed.x, displayed.y].join(',');
      })
      .join(' ');
  return (
    <>
      {items.map((item) => {
        const colour = pdfColour(item.geometry.colour);
        if (item.kind === 'ink')
          return (
            <polyline
              key={item.id}
              data-annotation-id={item.id}
              points={points(item.geometry.points as PdfPoint[])}
              fill="none"
              stroke="currentColor"
              className={colour.text}
              strokeWidth={Number(item.geometry.width) || 0.004}
              strokeLinecap="round"
              strokeLinejoin="round"
              pointerEvents="stroke"
            />
          );
        if (item.kind === 'highlight')
          return (
            <rect
              key={item.id}
              data-annotation-id={item.id}
              {...rotateRectangle(
                {
                  x: Number(item.geometry.x),
                  y: Number(item.geometry.y),
                  width: Number(item.geometry.width),
                  height: Number(item.geometry.height),
                },
                rotation,
              )}
              className={colour.text}
              fill="currentColor"
              fillOpacity="0.32"
            />
          );
        const point = rotatePoint(
          { x: Number(item.geometry.x), y: Number(item.geometry.y) },
          rotation,
        );
        return (
          <circle
            key={item.id}
            data-annotation-id={item.id}
            cx={point.x}
            cy={point.y}
            r="0.013"
            className="text-brand-coral"
            fill="currentColor"
            stroke="white"
            strokeWidth="0.003"
          />
        );
      })}
      {draft?.kind === 'ink' && (
        <polyline
          points={points(draft.points)}
          className={pdfColour(draft.colour).text}
          fill="none"
          stroke="currentColor"
          strokeWidth={draft.width}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
      {draft?.kind === 'highlight' && (
        <rect
          {...rotateRectangle(rectangle(draft.start, draft.end), rotation)}
          className={pdfColour(draft.colour).text}
          fill="currentColor"
          fillOpacity="0.32"
        />
      )}
      {notePoint && (
        <circle
          cx={rotatePoint(notePoint, rotation).x}
          cy={rotatePoint(notePoint, rotation).y}
          r="0.013"
          className="text-brand-coral"
          fill="currentColor"
        />
      )}
    </>
  );
}
